// Error tracking and performance monitoring
import { trackEvent } from './analytics';
import logger from './logger';

// Initialize error tracking
export const initializeErrorTracking = () => {
    // Basic error tracking without external dependencies
    window.addEventListener('error', (event) => {
        trackError('javascript_error', {
            message: event.message,
            filename: event.filename,
            lineno: event.lineno,
            colno: event.colno,
            stack: event.error?.stack
        });
    });

    window.addEventListener('unhandledrejection', (event) => {
        trackError('unhandled_promise_rejection', {
            reason: event.reason?.toString(),
            stack: event.reason?.stack
        });
    });

    logger.info('ERROR_TRACKING', 'Info');
};

// Track errors
export const trackError = (errorType, errorData = {}) => {
    trackEvent('error_occurred', {
        error_type: errorType,
        error_message: errorData.message || 'Unknown error',
        error_stack: errorData.stack,
        error_file: errorData.filename,
        error_line: errorData.lineno,
        error_column: errorData.colno,
        user_agent: navigator.userAgent,
        url: window.location.href,
        timestamp: new Date().toISOString(),
        ...errorData
    });

    // Log to console for debugging
    logger.error('ERROR_TRACKING', 'Error', errorData);
};

// Track performance issues
export const trackPerformanceIssue = (issueType, performanceData = {}) => {
    trackEvent('performance_issue', {
        issue_type: issueType, // 'slow_load', 'high_memory', 'slow_api'
        ...performanceData,
        timestamp: new Date().toISOString()
    });
};

// Track API errors
export const trackAPIError = (endpoint, method, statusCode, errorMessage, responseTime) => {
    trackEvent('api_error', {
        endpoint,
        method,
        status_code: statusCode,
        error_message: errorMessage,
        response_time: responseTime,
        timestamp: new Date().toISOString()
    });
};

// Track media loading issues
export const trackMediaError = (mediaType, mediaUrl, errorType, errorMessage) => {
    trackEvent('media_error', {
        media_type: mediaType, // 'video', 'audio', 'image'
        media_url: mediaUrl,
        error_type: errorType,
        error_message: errorMessage,
        timestamp: new Date().toISOString()
    });
};

// Track user-reported issues
export const trackUserReportedIssue = (issueType, description, userContext = {}) => {
    trackEvent('user_reported_issue', {
        issue_type: issueType,
        description,
        ...userContext,
        timestamp: new Date().toISOString()
    });
};

export default {
    initializeErrorTracking,
    trackError,
    trackPerformanceIssue,
    trackAPIError,
    trackMediaError,
    trackUserReportedIssue
};


